import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const inr = (n) => `Rs. ${Number(n || 0).toLocaleString('en-IN')}`;
const MAROON = [124, 37, 40];

// Builds a customer invoice PDF for one order using the site's company details.
function buildInvoice(order, company = {}) {
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const W = doc.internal.pageSize.getWidth();
  const M = 40;

  // Header band
  doc.setFillColor(...MAROON);
  doc.rect(0, 0, W, 90, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(20);
  doc.text(company.name || 'Golden Taj', M, 40);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  if (company.address) doc.text(company.address, M, 58);
  const contact = [company.phones?.[0] ? `+91 ${company.phones[0]}` : '', company.email].filter(Boolean).join('  |  ');
  if (contact) doc.text(contact, M, 72);

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(22);
  doc.text('INVOICE', W - M, 44, { align: 'right' });

  // Order meta
  let y = 120;
  doc.setTextColor(40, 40, 40);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text(`Order ${order.orderNumber}`, M, y);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(110, 110, 110);
  doc.text(`Date: ${new Date(order.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}`, M, y + 16);
  doc.text(`Payment: ${order.paymentMethod === 'online' ? 'Online' : 'COD'} (${order.paymentStatus})`, M, y + 30);
  doc.text(`Status: ${String(order.status).replace(/_/g, ' ')}`, M, y + 44);

  // Ship to
  const a = order.address || {};
  doc.setTextColor(40, 40, 40);
  doc.setFont('helvetica', 'bold');
  doc.text('Deliver To', W - M - 200, y, { align: 'left' });
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(110, 110, 110);
  const shipLines = [
    a.fullName,
    [a.line1, a.line2].filter(Boolean).join(', '),
    [a.city, a.state, a.pincode].filter(Boolean).join(', '),
    a.phone ? `+91 ${a.phone}` : '',
  ].filter(Boolean);
  shipLines.forEach((ln, i) => doc.text(String(ln), W - M - 200, y + 16 + i * 14, { maxWidth: 200 }));

  // Items table
  autoTable(doc, {
    startY: y + 70,
    head: [['Item', 'Pack', 'Qty', 'Price', 'Total']],
    body: (order.items || []).map((it) => [
      it.title,
      it.weight,
      String(it.qty),
      inr(it.price),
      inr(it.price * it.qty),
    ]),
    theme: 'striped',
    headStyles: { fillColor: MAROON, textColor: 255, fontStyle: 'bold' },
    styles: { fontSize: 10, cellPadding: 6 },
    columnStyles: { 2: { halign: 'center' }, 3: { halign: 'right' }, 4: { halign: 'right' } },
    margin: { left: M, right: M },
  });

  // Totals
  let ty = doc.lastAutoTable.finalY + 18;
  const rightX = W - M;
  const labelX = W - M - 180;
  const row = (label, value, bold) => {
    doc.setFont('helvetica', bold ? 'bold' : 'normal');
    doc.setTextColor(bold ? MAROON[0] : 90, bold ? MAROON[1] : 90, bold ? MAROON[2] : 90);
    doc.setFontSize(bold ? 12 : 10);
    doc.text(label, labelX, ty);
    doc.text(value, rightX, ty, { align: 'right' });
    ty += bold ? 20 : 16;
  };
  row('Item total', inr(order.itemsTotal));
  if (order.discount > 0) row(`Discount${order.couponCode ? ` (${order.couponCode})` : ''}`, `- ${inr(order.discount)}`);
  row('Delivery', order.deliveryFee ? inr(order.deliveryFee) : 'FREE');
  doc.setDrawColor(220, 220, 220);
  doc.line(labelX, ty - 6, rightX, ty - 6);
  row('Total Paid', inr(order.totalAmount), true);

  // Footer
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(150, 150, 150);
  doc.text('Thank you for shopping with us. This is a computer-generated invoice.', M, doc.internal.pageSize.getHeight() - 30);

  return doc;
}

export function downloadInvoice(order, company) {
  buildInvoice(order, company).save(`invoice-${order.orderNumber}.pdf`);
}
